import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/OutstandingPurchaseInvoiceReport/APReportOutstandingInvoiceAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportOutstandingInvoiceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/OutstandingPurchaseInvoiceReport/APReportOutstandingInvoice")
	}

	render() {
		return (
			<Activity 
				name="APReportOutstandingInvoice"
				RenderedComponent={this.RenderedComponent}
				context="APReportOutstandingInvoice"
				action="APReportOutstandingInvoice"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportOutstandingInvoiceActivity)
